module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/MODAL-plswait/plswait.component.css
// module id = ./src/app/components/MODAL-plswait/plswait.component.css
// module chunks = main